var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hot",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4872051,6.56334591 C13.7785642,9.20570955 12.2560108,10.7644805 11.4015599,10.1652723 C10.547109,9.56606405 11.760285,7.99973747 11.4015599,5.77839627 C11.1222396,4.04875535 10.236326,2.62554728 8.61736102,1.50978371 C8.52438459,3.57411849 8.12450895,4.88483939 7.11534437,6.06338185 C5.89355847,7.49023192 4.98903023,8.85921483 4.67521224,10.4307328 C4.36139425,12.0022507 4.71674985,14.0256806 6.85808767,15.5890334 C8.99942548,17.1523862 13.1340335,16.7129602 14.7721943,14.0256806 C16.0750648,11.8884194 15.3104249,8.58424472 13.4872051,6.56334591 Z",
    id: "Path",
    fill: "#FF6363"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.325620a28f17039e47e6712ed3569c41.svg";
export { ForwardRef as ReactComponent };